// extracted by mini-css-extract-plugin
export default {"carouselContainer":"carousel_carouselContainer__n1JUs","customSwiper":"carousel_customSwiper__ybKAD","bannerImage":"carousel_bannerImage__k668B"};